<template>
  <v-data-table :group-by="['_groupBy']" :headers="headers" :items="orderedValinnat" class="mt-2"
                disable-pagination
                hide-default-footer
  >
    <template v-slot:item.valintatyyppi="{item}">
      {{ item.valintatyyppi && item.valintatyyppi.nimi }}
    </template>
    <template v-slot:item.vastuualue="{item}">
      {{ item.vastuualue && item.vastuualue.nimi }}
    </template>
    <template v-slot:item._="{item}">
      <v-btn v-if="!disableEdit" icon @click="openEdit(item)">
        <v-icon small>mdi mdi-pencil</v-icon>
      </v-btn>
    </template>
    <template v-slot:group.header="{items}">

      <td class="text-subtitle-1 primary" colspan="100%">{{ items[0].vastuualue.nimi }}</td>

    </template>
  </v-data-table>
</template>

<script>
import orderBy from "lodash/orderBy";

export default {
  name: "ValintaTable",
  props: {
    valinnat: Array,
    disableEdit: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    orderedValinnat() {
      return orderBy(this.valinnat.map(v => {
        v._groupBy = `${v.vastuualue.jarjestysnumero}_${v.vastuualueId}`;
        return v;
      }), ['vuosi', 'vastuualue.jarjestysnumero', 'jarjestysnumero'], ['desc', 'asc', 'asc'])
    }
  },
  data() {
    return {
      headers: [
        {
          text: this.$t('valinta.otsikko'),
          value: 'otsikko'
        },
        {
          text: this.$t('valinta.vuosi'),
          value: 'vuosi'
        },
        {
          text: this.$tc('vastuualue.title', 1),
          value: 'vastuualue'
        },
        {
          text: this.$tc('valintatyyppi.title', 1),
          value: 'valintatyyppi'
        },
        {
          text: this.$t('valinta.jarjestysnumero'),
          value: 'jarjestysnumero'
        },
        {
          text: '',
          value: '_'
        }
      ]
    }
  },
  methods: {
    openEdit(item) {
      if (!item) {
        this.$router.push({name: 'asetukset_valinta_uusi'})
        return;
      }
      this.$router.push({name: 'asetukset_valinta_muokkaus', params: {id: item.id}})
    },
  }
}
</script>

<style scoped>

</style>